import React from 'react'
import { Outlet } from 'react-router-dom'

import BuyerHeader from "../Components/buyer/BuyerHeader"
import BuyerFooter from "../Components/buyer/BuyerFooter"
import FloatingChatWidget from "../Components/buyer/FloatingChatWidget"

function Layout( {isFooter = true} ) {

    if(!isFooter){
        return (
            <div>
                <BuyerHeader />
                <Outlet />
                <FloatingChatWidget />
            </div>
        )
    }

    return (
        <div>
            <BuyerHeader />
            <Outlet />
            <BuyerFooter />
            <FloatingChatWidget />
        </div>
    )
}

export default Layout